import type * as core from '../../../../../../../core'

const filter = {
  and: [
    {
      or: [
        {
          '=': [
            {
              '``': {
                '@$': 'jiraStatusFilter',
              },
            },
            null,
          ],
        },
        {
          '=': [
            {
              '@.': '!jira_status',
            },
            {
              '``': {
                '@$': 'jiraStatusFilter',
              },
            },
          ],
        },
        {
          and: [
            {
              '=': [
                {
                  '``': {
                    '@$': 'jiraStatusFilter',
                  },
                },
                'Unknown',
              ],
            },
            {
              '=': [
                {
                  '@.': '!jira_status',
                },
                null,
              ],
            },
          ],
        },
      ],
    },
    {
      or: [
        {
          '=': [
            {
              '``': {
                '@$': 'typeFilter',
              },
            },
            null,
          ],
        },
        {
          '=': [
            {
              '@.': '!type',
            },
            {
              '``': {
                '@$': 'typeFilter',
              },
            },
          ],
        },
      ],
    },
    {
      or: [
        {
          '=': [
            {
              '`': {
                '``': {
                  '@$': 'assigneeFilter',
                },
              },
            },
            null,
          ],
        },
        {
          in: [
            {
              '@.': ['!assignee', { ref: { entity: '!employee' } }],
            },
            {
              '@>': [
                {
                  '`': {
                    '``': {
                      '@$': 'assigneeFilter',
                    },
                  },
                },
                'ent:!personnel:!employee',
              ],
            },
          ],
        },
      ],
    },
    {
      or: [
        {
          '=': [
            {
              '``': {
                '@$': 'dueDateFilter',
              },
            },
            null,
          ],
        },
        {
          '=': [
            {
              '@.': '!due_date',
            },
            {
              '``': {
                '@$': 'dueDateFilter',
              },
            },
          ],
        },
      ],
    },
  ],
}

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Requirements',
      type: 'table',
      content: {
        '{}': {
          count: {
            '`': {
              filter,
              selection: {
                '#': {
                  '@': 'requirements',
                },
              },
              subqueries: {
                requirements: {
                  filter: {
                    and: [
                      {
                        or: [
                          {
                            '=': [
                              { '`': { '``': { '@$': 'projectId' } } },
                              null,
                            ],
                          },
                          {
                            '=': [
                              { '@': 'specProject' },
                              {
                                '@>': [
                                  { '`': { '``': { '@$': 'projectId' } } },
                                  'recordId',
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      filter,
                    ],
                  },
                  target: 'ent:!requirements:!requirement',
                  subqueries: {
                    specProject: {
                      ref: {
                        attr: 'attr:ent#!requirements#!requirement:!spec',
                      },
                      target: 'ent:!specs:!spec',
                      selection: {
                        '@.': ['!project', { ref: { entity: '!proj' } }],
                      },
                    },
                  },
                },
              },
            },
          },
          query: {
            '`': {
              filter: {
                and: [
                  {
                    or: [
                      { '=': [{ '`': { '``': { '@$': 'projectId' } } }, null] },
                      {
                        '=': [
                          { '@': 'specProject' },
                          {
                            '@>': [
                              { '`': { '``': { '@$': 'projectId' } } },
                              'recordId',
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  filter,
                ],
              },
              sort: {
                by: {
                  '@.': '!id',
                },
              },
              target: 'ent:!requirements:!requirement',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      issue: {
                        '{}': {
                          value: {
                            '@.': '!code',
                          },
                        },
                      },
                      jiraStatus: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '@.': '!jira_status',
                              },
                              'Unknown',
                            ],
                          },
                        },
                      },
                      summary: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      assignee: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '@': 'assigneeName',
                              },
                              'Unassigned',
                            ],
                          },
                        },
                      },
                      priority: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '@.': '!priority',
                              },
                              'unknown',
                            ],
                          },
                        },
                      },
                      type: {
                        '{}': {
                          value: {
                            '@.': '!type',
                          },
                        },
                      },
                      dueDate: {
                        '{}': {
                          value: {
                            '@.': '!due_date',
                          },
                        },
                      },
                    },
                  },
                  onClick: {
                    '{}': {
                      action: {
                        '{}': {
                          payload: {
                            '{}': {
                              agentId: 'workPacketGenerator',
                              records: {
                                '[]': [
                                  {
                                    '{}': {
                                      modelId: 'ent:!requirements:!requirement',
                                      recordId: {
                                        '@.': '!id',
                                      },
                                    },
                                  },
                                ],
                              },
                            },
                          },
                          operation: 'ui.open-assistant',
                        },
                      },
                      variables: {
                        '{}': {
                          reqId: {
                            '@.': '!id',
                          },
                        },
                      },
                    },
                  },
                  overflowActions: {
                    '[]': [
                      {
                        '{}': {
                          icon: 'atn-icon atn-link',
                          name: 'View Requirement Details',
                          action: {
                            '{}': {
                              payload: {
                                '{}': {
                                  goto: {
                                    '{}': {
                                      variables: {
                                        '{}': {
                                          reqID: {
                                            '@.': '!id',
                                          },
                                        },
                                      },
                                      navigationId: 'requirement.details',
                                    },
                                  },
                                },
                              },
                              operation: 'ui.navigate',
                            },
                          },
                        },
                      },
                    ],
                  },
                },
              },
              subqueries: {
                specProject: {
                  ref: { attr: 'attr:ent#!requirements#!requirement:!spec' },
                  target: 'ent:!specs:!spec',
                  selection: {
                    '@.': ['!project', { ref: { entity: '!proj' } }],
                  },
                },
                assigneeName: {
                  ref: {
                    attr: 'attr:ent#!requirements#!requirement:!assignee',
                  },
                  target: 'ent:!personnel:!employee',
                  quantity: 1,
                  selection: {
                    '@.': '!name',
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'issue',
                  direct: {
                    '{}': {
                      name: 'Issue',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'summary',
                  direct: {
                    '{}': {
                      name: 'Summary',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'jiraStatus',
                  dmsAttr: {
                    '{}': {
                      attributeId:
                        'attr:ent#!requirements#!requirement:!jira_status',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'assignee',
                  direct: {
                    '{}': {
                      name: 'Assignee',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'priority',
                  direct: {
                    '{}': {
                      name: 'Priority',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'type',
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!requirements#!requirement:!type',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'dueDate',
                  direct: {
                    '{}': {
                      name: 'Due Date',
                      type: 'DATE',
                    },
                  },
                  isSortable: true,
                },
              },
            ],
          },
        },
      },
    },
  },
  variables: {
    jiraStatusFilter: null,
    typeFilter: null,
    assigneeFilter: null,
    dueDateFilter: null,
  },
}
